<template>
  <div class="bidders-list tab-table">
    <InvoicesTable :exclude-columns="['sale_no']" :hide-actions="hideActions"
                   :hide-action-buttons="hideActionButtons" :exclude-types-from-filter="['service']"
                   :exclude-search-fields="['sale_no', 'shipping_status']"
                   :accounting-system-params="{sale_no: sale.sale_no}" enable-frontend-export
    />
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import InvoicesTable from "../../../invoices/InvoicesTable";
  import {
    ACTION_CREATE_DEPOSIT_INVOICE,
    ACTION_CREATE_MANUAL_INVOICE,
    ACTION_CREATE_SERVICE_INVOICE,
    ACTION_BATCH_SHIPPING_CHARGES,
    ACTION_MARK_INVOICE_DISPATCHED,
    ACTION_UNMARK_INVOICE_DISPATCHED,
  } from "@/modules/constants";

  const {mapState} = createNamespacedHelpers('sales');
  const {mapActions: invoicesMapActions} = createNamespacedHelpers('invoices');

  export default {
    name: "InvoicesList",
    components: {InvoicesTable},
    data() {
      return {
        hideActions: [
          ACTION_CREATE_MANUAL_INVOICE,
          ACTION_CREATE_DEPOSIT_INVOICE,
          ACTION_MARK_INVOICE_DISPATCHED,
          ACTION_UNMARK_INVOICE_DISPATCHED,
          ACTION_CREATE_SERVICE_INVOICE,
          ACTION_BATCH_SHIPPING_CHARGES,
        ],
        hideActionButtons: [],
      }
    },
    computed: {
      ...mapState({
        sale: state => state.view.currentSale
      })
    },
    methods: {
      ...invoicesMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'sale',
        extraFilters: {auction_uuid: this.sale.uuid},
        sale: this.sale,
      });
    }
  }
</script>

<style lang="scss" scoped>
</style>
